import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { memo } from 'react';

interface LoadingOverlayProps {
  top?: number;
}

export const LoadingOverlay = memo(({ top = 0 }: LoadingOverlayProps) => {
  return (
    <Box sx={{ position: 'absolute', top, left: 0, right: 0, width: '100%' }}>
      <LinearProgress
        variant="indeterminate"
        color="primary"
        sx={{ height: '0.25rem' }}
      />
    </Box>
  );
});
